import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {TarafRol} from "../enum/uyap/TarafRol";

export interface GetDosyaTarafListesiWithTarafRolTalep {
    dosyaId: string,
    islemTuru: TarafRol
}

export type GetDosyaTarafListesiWithTarafRolCevap = Array<ITarafBilgisiDetayliTarafRollu>

export interface ITarafBilgisiDetayliTarafRollu {
    kisiKurumBilgileriDVO: IKisiKurumBilgileriDVO,
    dosyaKisiDVO: IDosyaKisiDVO,
    secili: boolean,
    dogacakHakDahilmi: boolean,
    borcluBelediye: boolean,
    maasHesabiHaric: boolean,
    kisiMiKurumMu: number,
    guncelKisiKurumId: number,
    ilkKisiKurumId: number,
    tarafRolu: TarafRol,
    davaliDavaciGrup: string,
    aboneVarmi: boolean,
    tarafAdi: string
}

interface IKisiKurumBilgileriDVO {
    adresList: Array<any>,
    kisiKurumId: number,
    kurumDVO: IKurumDVO,
    turu: number,
    ortakAd: string
}

interface IKurumDVO {
    kisiKurumID: number,
    kurumAdi: string,
    vergiNo: string,
    ticaretSicilNo?: string,
    harcDurumu: number,
    kamuOzel: string,
    sskIsyeriSicilNo?: string,
    mersisNo?: string,
    veriGelisYeri: number,
    faaliyetDurumu: number,
    ortakBilgileri: Array<IOrtakBilgileri>,
    temsilciBilgileri: Array<ITemsilciBilgileri>,
    sermayesi?: number,
    tescilTarihi?: string,
    tacirMi: string,
    mersisIlKodu: number,
    mersisIlceKodu: number,
    vergiDairesi?: string
}

interface IOrtakBilgileri {
    ortakTipi: number,
    adi: string,
    soyadi: string,
    kisikurum_id: number,
    tcKimlikNo: string
}

interface ITemsilciBilgileri {
    tcKimlikNo: string,
    adi: string,
    soyadi: string,
    temsilciTipi: number,
    kisikurum_id: number,
    KisiTipiKodu: number,
    yetkiSuresiGun: number,
    yetkiSuresiAy: number,
    yetkiSuresiYil: number
}

interface IDosyaKisiDVO {
    kisiBilgDVO: IKisiBilgDVO,
    kurumBilgDVO: IKurumBilgDVO,
    dosyaBilg: IDosyaBilg,
    dosyasiIncelenebilir: boolean,
    kisiMiKurumMu: number,
    guncelKisiKurumId: number,
    ilkKisiKurumId: number,
    dosyaId: string,
    tarafRolu: TarafRol,
    dosyaKisiId: number,
    dosyaDurumuAktif: string,
    kimlikBilgisiAktif: string,
    kayitId: number,
    sanikStatusunde: string,
    davaliDavaciGrup: string,
    aboneVarmi: boolean,
    tarafAdi: string,
    tarafTC: string,
    cbsGroup: number,
    tarafDurumu?: number
}

interface IKisiBilgDVO {
    harcDurumu: number,
    ozurOrani: number,
    isEngelliKisiKurum: boolean
}

interface IKurumBilgDVO {
    kurumAdi: string,
    kurumVergiNo: string,
    kurumTicaretSicilNo?: string,
    harcDurumu: number,
    kamuOzel: string,
    isEngelliKisiKurum: boolean
}

interface IDosyaBilg {
    dosyaDurumu: number,
    dosyaAcilisTarihi: string,
    dosyaNoSira: number,
    dosyaNoYil: number,
    dosyaNo: string,
    birimId: string,
    dosyaTurKod: number
}

export default class GetDosyaTarafListesiWithTarafRol extends UyapRequest<GetDosyaTarafListesiWithTarafRolTalep, GetDosyaTarafListesiWithTarafRolCevap> {
    getMethod(): "POST" | "GET" {
        return 'POST';
    }
    getSpinnerMessage(){
        return "Dosya taraf listesi getiriliyor...";
    }
    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "GetDosyaTarafListesiWithTarafRol_" + app.$uyapHelper.hashTalepForCache(this.talepData)
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "getDosyaTarafListesiWithTarafRol.ajx";
    }

    async parse(data: any): Promise<GetDosyaTarafListesiWithTarafRolCevap> {
        return data;
    }

    getMockResponse(): any {
        return [{"kisiKurumBilgileriDVO":{"kisiKurumId":198399381,"kurumDVO":{"kisiKurumID":198399381,"kurumAdi":"İZZET DEMİRCİOĞLU YEM TARIM ÜRÜNLERİ HAYVANCILIK GIDA TURİZM OTOMOTİV TAŞIMACILIK SANAYİ TİCARET LİMİTED ŞİRKETİ","vergiNo":"4840722602","ticaretSicilNo":"443","harcDurumu":1,"kamuOzel":"O","sskIsyeriSicilNo":"264-AYAŞ","mersisNo":"0484072260200016","veriGelisYeri":0,"faaliyetDurumu":1,"ortakBilgileri":[{"ortakTipi":2,"adi":"İZZET","soyadi":"DEMİRCİOĞLU","kisikurum_id":198399381,"tcKimlikNo":"25145706001"},{"ortakTipi":2,"adi":"SERAP","soyadi":"DEMİRCİOĞLU","kisikurum_id":198399381,"tcKimlikNo":"25147266493"},{"ortakTipi":2,"adi":"İZZET","soyadi":"DEMİRCİOĞLU","kisikurum_id":198399381,"tcKimlikNo":"25133143503"},{"ortakTipi":2,"adi":"İZZET","soyadi":"DEMİRCİOĞLU","kisikurum_id":198399381,"tcKimlikNo":"12559042288"},{"ortakTipi":2,"adi":"SERAP ","soyadi":"DEMİRCİOĞLU","kisikurum_id":198399381,"tcKimlikNo":"12532043066"}],"temsilciBilgileri":[{"tcKimlikNo":"25143216661","adi":"İZZET DEMİRCİOĞLU 10 YIL SÜRE","soyadi":"İLE","temsilciTipi":3,"kisikurum_id":198399381,"KisiTipiKodu":0,"yetkiSuresiGun":0,"yetkiSuresiAy":0,"yetkiSuresiYil":0},{"tcKimlikNo":"25138494855","adi":"İZZET","soyadi":"DEMİRCİOĞLU","temsilciTipi":3,"kisikurum_id":198399381,"KisiTipiKodu":0,"yetkiSuresiGun":0,"yetkiSuresiAy":0,"yetkiSuresiYil":0},{"tcKimlikNo":"25138501377","adi":"İZZET","soyadi":"DEMİRCİOĞLU","temsilciTipi":3,"kisikurum_id":198399381,"KisiTipiKodu":0,"yetkiSuresiGun":0,"yetkiSuresiAy":0,"yetkiSuresiYil":0},{"tcKimlikNo":"12559042288","adi":"İZZET","soyadi":"DEMİRCİOĞLU","temsilciTipi":3,"kisikurum_id":198399381,"KisiTipiKodu":0,"yetkiSuresiGun":0,"yetkiSuresiAy":0,"yetkiSuresiYil":0}],"sermayesi":950000,"tescilTarihi":"10/12/2007","tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0},"turu":1,"ortakAd":"İZZET DEMİRCİOĞLU YEM TARIM ÜRÜNLERİ HAYVANCILIK GIDA TURİZM OTOMOTİV TAŞIMACILIK SANAYİ TİCARET LİMİTED ŞİRKETİ","adresList":[]},"dosyaKisiDVO":{"kisiBilgDVO":{"harcDurumu":1,"ozurOrani":0,"isEngelliKisiKurum":false},"kurumBilgDVO":{"kurumAdi":"İZZET DEMİRCİOĞLU YEM TARIM ÜRÜNLERİ HAYVANCILIK GIDA TURİZM OTOMOTİV TAŞIMACILIK SANAYİ TİCARET LİMİTED ŞİRKETİ","kurumVergiNo":"4840722602","kurumTicaretSicilNo":"443","harcDurumu":1,"kamuOzel":"O","isEngelliKisiKurum":false},"dosyaBilg":{"dosyaDurumu":0,"dosyaAcilisTarihi":"Sep 4, 2013 12:10:22 PM","dosyaNoSira":14182,"dosyaNoYil":2013,"dosyaNo":"2013/14182","birimId":"1000950","dosyaTurKod":35},"dosyasiIncelenebilir":true,"kisiMiKurumMu":1,"guncelKisiKurumId":198399381,"ilkKisiKurumId":198399381,"dosyaId":"5aeQ8ejIXsRCzbpCLpM33mxLpW0gRZnDBNQP@1wgA3nbPyiNeayXnd+wW4mrpHUJ","tarafRolu":71,"dosyaKisiId":1412443802,"dosyaDurumuAktif":"E","kimlikBilgisiAktif":"E","kayitId":13098737882,"sanikStatusunde":"H","davaliDavaciGrup":"N","aboneVarmi":true,"tarafAdi":"İZZET DEMİRCİOĞLU YEM TARIM ÜRÜNLERİ HAYVANCILIK GIDA TURİZM OTOMOTİV TAŞIMACILIK SANAYİ TİCARET LİMİTED ŞİRKETİ","tarafTC":"4840722602","cbsGroup":-1},"secili":false,"dogacakHakDahilmi":false,"borcluBelediye":false,"maasHesabiHaric":false,"kisiMiKurumMu":1,"guncelKisiKurumId":198399381,"ilkKisiKurumId":198399381,"tarafRolu":71,"davaliDavaciGrup":"N","aboneVarmi":true,"tarafAdi":"İZZET DEMİRCİOĞLU YEM TARIM ÜRÜNLERİ HAYVANCILIK GIDA TURİZM OTOMOTİV TAŞIMACILIK SANAYİ TİCARET LİMİTED ŞİRKETİ"}];
    }
}